import * as React from "react";
import { useParameter } from "../../../shared";

export function useSlideTitle() {
  const [business] = useParameter<number>("@business-units");
  const bname = (business || 1) === 2 ? "APE" : "World";
  const bcrops = (business || 1) === 2 ? "" : "AP";

  const title = `${bname} overview - ${bcrops} major crops: annual area development (in %)`;

  return title;
}
